import React, { useState, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { useDropzone } from 'react-dropzone';

interface ICreateAffiliate {
  setCreateMode: any;
  cur_user: any;
  createAffiliate: any;
}

const CreateAffiliate: React.FC<ICreateAffiliate> = ({ createAffiliate, setCreateMode, cur_user }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [ file, setFile ] = useState<any>([]);

  const removeFile = () => {
    setFile([]);
  };

  const onDrop = useCallback((acceptedFiles: File[]) => {
    acceptedFiles.forEach(async(accptFile) => {
      const reader = new FileReader();
      reader.onabort = () => {
        enqueueSnackbar('File reading aborted', { variant: 'info' });
      };
      reader.onerror = () => {
        enqueueSnackbar('Error reading file', { variant: 'error' });
      };

      setFile(accptFile);
    });
  }, []);

  const fileValidator = (file: any) => {
    if (file.size > 20000000) {
      enqueueSnackbar('Your file is too large, upload a file less than 20mbs', { variant: 'error' });
      return {
        code: 'size-too-large',
        message: 'file is larger than 20MB',
      };
    }
    return null;
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: onDrop,
    validator: fileValidator,
    accept: 'image/jpeg, image/jpg, image/png',
  });

  return (
    <div className='create-affiliate-container'>
      <div className='browse-affiliates-header'>
        <div className='browse-affiliates-header-content'>
          <div className='browse-affiliates-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M12 5V19M5 12H19' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <div className='browse-affiliates-header-group'>
            <div className='browse-affiliates-header-primary'>
              Create Affiliation Group
            </div>
            <div className='browse-affiliates-header-secondary'>
              This allows your team to become an organization that can share
              documents and templates with other teams. They can then access,
              fill out, then screen these documents on their own. Your affiliate
              group name is the same as your team name.
            </div>
          </div>
        </div>
        <div className='browse-affiliates-header-close' onClick={() => setCreateMode(false)}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      <div className='create-affiliate-body'>
        <div className='create-affiliate-body-name'>
          <div className='create-affiliate-body-title'>
            1. Affiliate Name
          </div>
          <div className='create-affiliate-body-name-input'>
            <div className='create-affiliate-body-name-input-content'>
              <div className='create-affiliate-body-name-input-frame'>
                <div className='create-affiliate-body-name-input-inner'>
                  <div className='create-affiliate-body-name-input-text'>
                    {cur_user.selected_team.name}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='create-affiliate-body-icon'>
          <div className='create-affiliate-body-title-frame'>
            <div className='create-affiliate-body-title'>
              2. Upload Logo
            </div>
          </div>
          <div className='create-affiliate-body-image-upload'>
            <div {...getRootProps()} style={{ width: '100%' }}>
              <div className={`files-container-empty ${file?.name ? 'file-uploaded' : ''}`}>
                {file?.name ? (<>
                  <p className='files-container-text'>
                    <span className='bill-container-fit-screen-content-row-highlight-blue cursor-pointer'>{file.name} </span>
                    <svg onClick={removeFile} width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <g id='trash-03'>
                        <path id='Icon' d='M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                      </g>
                    </svg>
                  </p>
                </>
                ) : (
                  <>
                    <p className='files-container-text'>
                      <span className='bill-container-fit-screen-content-row-highlight-blue cursor-pointer'>Click to upload</span> or drag and drop</p>
                    <p className='files-container-text'>Image (.jpg, .jpeg, .png) file format only (max 200 MB)</p>
                    <input {...getInputProps()} />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='create-affiliate-footer'>
        <div className='create-affiliate-footer-wrap'>
          <svg
            style={{ fill: '#2E3036', height: '8px', alignSelf: 'stretch', width: '100%' }}
            xmlns='http://www.w3.org/2000/svg' width='452' height='1' viewBox='0 0 452 1' fill='none'
          >
            <path fillRule='evenodd' clipRule='evenodd' d='M452 1H0V0H452V1Z' fill='#2E3036'/>
          </svg>
        </div>
        <div className='create-affiliate-footer-actions'>
          <div className='create-affiliate-footer-btn-group'>
            <div className='create-affiliate-footer-btn-cancel' onClick={() => setCreateMode(false)}>
              <div className='create-affiliate-footer-btn-cancel-text'>
                Cancel
              </div>
            </div>
            <div className='create-affiliate-footer-btn-create' onClick={() => createAffiliate(file)}>
              <div className='create-affiliate-footer-btn-create-text'>
                Create
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateAffiliate;
